import sanitizeHtml from 'sanitize-html'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig, type PageConfig } from '@segment/contexts/page'

import EmpowerMarketersImage from './EmpowerMarketersImage'

const getCopy = (pageConfig: PageConfig) => ({
  heading: `Empower marketers with the data they need`,
  description: `<a href="${getAbsoluteUrl(
    `/product/twilio-engage/audiences/`,
    pageConfig
  )}">Segment Linked Audiences</a> simplifies audience segmentation for B2B and B2C marketers, enhancing personalization by directly integrating with your data warehouse. Craft flexible segments with the audience builder tool to boost marketing effectiveness across various channels.`,
})

const EmpowerMarketers = () => {
  const pageConfig = usePageConfig()
  const { heading, description } = getCopy(pageConfig)
  return (
    <SectionBase variant="2Col" reverse={true}>
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h3">{heading}</CopyText.Heading>
          <CopyText.Description
            tag="p"
            variant="pLarge"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(description, { allowedTags: [`a`] }),
            }}
          />
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <EmpowerMarketersImage />
      </Section.Contents>
    </SectionBase>
  )
}

export default EmpowerMarketers
